export const PAGE_TITLE = "The Life Mastery Course";

export const PAGE_TEXT =
  "The <b>Life Mastery Course</b>, created by <b>Matthew J. Brownstein</b>, empowers individuals to harness the power of their minds to achieve success in every aspect of life. Rooted in the principles of self-actualization, this course helps transform every category of your life into a thriving example of success.";

export const VIDEO_URL =
  "https://drive.google.com/file/d/1FtDNZswVmV8MbZ0JnCf5oZCqtRvVh4LF/preview";

export const SNACKBAR_SUCCESS_MESSAGE = "Wheel Of Life saved successfully";

export const SECTION_TITLES = {
  ACCESS: "Ways to Access the Life Mastery Course",
  TWO_PART_PROCESS: "The Two-Part Process:",
};

export const FOOTER_TEXT =
  "The Life Mastery Course provides a comprehensive approach to turning aspirations into reality by blending organization, alignment, and actionable techniques. Whether through private sessions, formal training, or self-paced learning, this course offers the tools you need to thrive in every area of life.";

export const LIFE_MASTERY_DATA = [
  {
    id: 5,
    title: "CEU Course",
    text: "Access a 10-hour pre-recorded course with Matthew J. Brownstein offered through the <b>IAIH.</b>",
    text2: "Follow the step-by-step Life Mastery process at your own pace.",
    link: "https://www.instituteofhypnotherapy.com/ceu/advanced-life-mastery-course/",
    size: 5,
  },
  {
    id: 7,
    title: "The Wheel of Life",
    openModalHeader: true,
    wheelOfLife: true,
    height: "575px",
    size: 7,
  },
  {
    id: 1,
    title: "The Getting Organized Process",
    text: "Gain clarity on your <b>mission and purpose, principles and values,</b> and <b>universal laws.</b>",
    text2:
      "Define your life categories and set clear <b>long-term, mid-range, and short-term goals.</b>",
    text3:
      "Create actionable tools like a <b>to-do list, calendar,</b> and <b>dream board</b> to stay organized and focused.",
    bigH: true,
  },

  {
    id: 2,
    title: "The Creating and Manifesting Process",
    text: "Align your mind to manifest goals identified in your Getting Organized Process.",
    text2:
      "Utilize techniques like: <br /> <ul><li>Clarity of intent</li><li>Meditation and visualization</li><li>Cultivating strong positive emotions</li><li>Using suggestions and affirmations</li></ul>",
    text3:
      "Leverage the power of belief, desire, acceptance, expectation, commitment, and surrender to create tangible results.",
    bigH: true,
  },

  // {
  //   id: 3,
  //   title: "Private Sessions",
  //   text: "Work one-on-one with IIH graduates to apply the Life Mastery process to your personal and professional goals.",
  // },
  {
    id: 4,
    title: "Through IIH Training",
    text: "Gain seven hours of instruction on this system during the <b>Advanced Hypnotism section</b> of IIH Training.",
    text2: "Learn how to use this model for yourself and your clients.",
    link: "https://www.instituteofhypnotherapy.com/course/certified-hypnotherapist/",
  },

  // {
  //   id: 6,
  //   title: "Dashboard-Based Life Mastery",
  //   text: "Use an online dashboard to work through the entire process and track your progress.",
  //   link: "https://drive.google.com/drive/u/0/folders/1nR5-YHCNH6wfE1xzSSrnpEIgKu7eiWCt",
  // },
];
